import { LoginDataFormValues, ForgottenPasswordDataFormValues } from './types';

export const loginDataKeys: { [K in keyof LoginDataFormValues]: K } = {
    email: 'email',
    password: 'password',
};

export const forgottenPasswordDataKeys: { [K in keyof ForgottenPasswordDataFormValues]: K } = {
    email: 'email',
    password: 'password',
};
